'use strict';

var DataExtractPanelConfig = function DataExtractPanelConfig($stateProvider) {
  $stateProvider.state('app.data-extract', {
    url: '/workflow/data-extract',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/data-extract-panel.html'),
        controller: 'DataExtractPanelController'
      },
      'mainToolbar': {
        template: require('../templates/data-extract-toolbar.html'),
        controller: 'DataExtractToolbarController'
      }
    }
  });
};
module.exports = DataExtractPanelConfig;
DataExtractPanelConfig.$inject = ['$stateProvider'];